var DiscountType = /* @__PURE__ */ ((DiscountType2) => {
  DiscountType2["Absolute"] = "ABSOLUTE";
  DiscountType2["Relative"] = "RELATIVE";
  return DiscountType2;
})(DiscountType || {});
export {
  DiscountType
};
//# sourceMappingURL=types.js.map
